import React from 'react';
import FormPart from '../Form/FormPart';
import { isEqualTo, isNotEmpty } from '../util/check';
import fieldMap from '../Form/FieldMap';
export default class BatchEdit extends React.Component {
    constructor(...args) {
        super(...args);

        this.onChangeHandler = this.onChangeHandler.bind(this);
        this.onBlurHandler = this.onBlurHandler.bind(this);
        this.onFocusHandler = this.onFocusHandler.bind(this);
        this.uploadFielSuccessHandle = this.uploadFielSuccessHandle.bind(this);
        this.deleteFileHandle = this.deleteFileHandle.bind(this);

        this.state = {
            currentRenderField: {
                field_name: ''
            },
            biz_data: {
                __DEFAULT_DROPDOWNLIST__: ''
            },
            validate_errors: {
                error: false,
                message: ''
            }
        };

        this.uploadFieldCmpData = {};
    }

    get currentRenderFieldName() {
        return this.state.currentRenderField.field_name;
    }

    get currentRenderFieldBizData() {
        return this.state.biz_data[this.currentRenderFieldName];
    }

    componentDidMount() {
        let params = this.props.popOptions.params.fieldFilterKey
            ? Object.assign(
                  {},
                  { metaObjName: this.props.popOptions.cmpContext.metaObjName },
                  {
                      fieldFilterKey: this.props.popOptions.params
                          .fieldFilterKey
                  }
              )
            : Object.assign(
                  {},
                  { metaObjName: this.props.popOptions.cmpContext.metaObjName }
              );
        //获取可编辑字段
        this.props.actions.getEditableFields(params);
    }

    componentWillReceiveProps(nextProps, nextState) {}

    assambleBizData() {
        let biz_data = {};
        if (this.state.renderField) {
            biz_data[this.props.cmp_data.field_name] = {
                text: this.state.renderField.text || '',
                value: this.state.renderField.value || ''
            };
        } else {
            biz_data = '';
        }
        return biz_data;
    }

    getEditableFields() {
        return this.props.batchEdit.sub_cmps.map(field => {
            return { text: field.cmp_label, value: field.cmp_data.field_name };
        });
    }

    //组装下拉框元数据
    assambelDropDownDef() {
        const { letField } = this.props.translation;
        let dropDownDef = {};
        dropDownDef.cmp_type = 'BC_DropDownList';
        dropDownDef.cmp_label = letField;
        dropDownDef.cmp_data = {};
        dropDownDef.cmp_data.title = letField;
        dropDownDef.cmp_data.field_name = '__DEFAULT_DROPDOWNLIST__';
        dropDownDef.cmp_data.required = true;
        dropDownDef.cmp_data.metaObjectName =
            this.props.popOptions.cmpContext.metaObjectName ||
            this.props.popOptions.cmpContext.metaObjName;
        dropDownDef.cmp_data.datasource = this.getEditableFields();
        return dropDownDef;
    }

    assambleFormPartDef() {
        let formPartDef = {
            cmp_id: '___DEFAULT_FORMPART__',
            cmp_data: {
                title: '',
                visible: true
            },
            sub_cmps: [this.assambelDropDownDef()]
        };

        let currentRenderFieldCmp = this.getCurrentRenderField();
        if (currentRenderFieldCmp) {
            if (
                currentRenderFieldCmp.cmp_type === 'BC_FileUploader' ||
                currentRenderFieldCmp.cmp_type === 'BC_PictureUploader'
            ) {
                currentRenderFieldCmp = Object.assign(currentRenderFieldCmp, {
                    cmp_data: this.uploadFieldCmpData
                });
            }
            formPartDef.sub_cmps[1] = currentRenderFieldCmp;
        }

        return formPartDef;
    }

    getCurrentRenderField() {
        if (this.state.currentRenderField.field_name === '') {
            return null;
        }

        const currendRenderFieldCmpData = this.props.batchEdit.sub_cmps.find(
            field => {
                return isEqualTo(
                    field,
                    ['cmp_data', 'field_name'],
                    this.state.currentRenderField.field_name
                );
            }
        );

        return currendRenderFieldCmpData;
    }

    getDataSourceDef(field) {
        let dataSourceQuery = [];
        if (field.cmp_type != 'BC_PopArea') {
            dataSourceQuery.push({
                fieldName: field.cmp_data.field_name,
                filter: '',
                dsName: field.cmp_data.datasourcename
            });
        }
        return dataSourceQuery;
    }

    changeCurrentRenderedField(dropDownValue) {
        let biz_data = {
            __DEFAULT_DROPDOWNLIST__: {
                text: dropDownValue.text,
                value: dropDownValue.value
            }
        };

        const fieldCmp = this.props.batchEdit.sub_cmps.find(field => {
            return isEqualTo(
                field,
                ['cmp_data', 'field_name'],
                dropDownValue.value
            );
        });

        if (fieldCmp) {
            if (
                fieldCmp.cmp_type === 'BC_FileUploader' ||
                fieldCmp.cmp_type === 'BC_PictureUploader'
            ) {
                this.uploadFieldCmpData = Object.assign({}, fieldCmp.cmp_data);
            }

            this.props.actions.fetchShowFieldDataSource(
                fieldCmp.cmp_id,
                this.getMetaObjectName(fieldCmp),
                this.getDataSourceDef(fieldCmp)
            );

            biz_data[fieldCmp.cmp_data.field_name] = {};
            this.setState({
                currentRenderField: {
                    field_name: fieldCmp.cmp_data.field_name
                },
                biz_data: biz_data,
                validate_errors: {
                    error: false,
                    message: ''
                }
            });
            return null;
        }

        this.setState({ biz_data: biz_data });
    }

    changeRenderedFieldValue(bizData) {
        const fieldCmp = this.props.batchEdit.sub_cmps.find(field => {
            return isEqualTo(field, ['cmp_data', 'field_name'], bizData.name);
        });

        if (fieldCmp) {
            let biz_data = {
                __DEFAULT_DROPDOWNLIST__: this.state.biz_data[
                    '__DEFAULT_DROPDOWNLIST__'
                ]
            };
            biz_data[fieldCmp.cmp_data.field_name] = {
                text: bizData.text,
                value: bizData.value
            };

            this.setState({ biz_data: biz_data }, function() {
                this.isBluring = false;
                if (this.isSaving) {
                    this.save();
                }
            });
        }
    }

    onChangeHandler(obj, cmp_relative_data, validators) {
        if (obj.name === '__DEFAULT_DROPDOWNLIST__') {
            this.changeCurrentRenderedField(obj);
        } else {
            this.changeRenderedFieldValue(obj);
        }
    }

    onBlurHandler(obj, cmp_relative_data, validators) {
        this.isBluring = true;
        this.changeRenderedFieldValue(obj);
    }

    onFocusHandler(value, cmp_relative_data, validators) {}

    deleteFileHandle(form_id, cmp_id, field_name, val) {
        this.uploadFieldCmpData = Object.assign(this.uploadFieldCmpData, {
            clientUrl: val.clientUrl,
            downloadUrl: val.downLoadUrl,
            fileName: val.fileName
        });

        this.changeRenderedFieldValue({ text: val.text, value: val.value });
    }

    uploadFielSuccessHandle(
        uploadResponse,
        form_id,
        cmp_id,
        field_name,
        isMultiple
    ) {
        let filedComponentBizData = {};
        let fileUrls = {};
        if (isMultiple) {
            filedComponentBizData = {
                text:
                    this.currentRenderFieldBizData &&
                    this.currentRenderFieldBizData.text
                        ? this.currentRenderFieldBizData.text +
                          ',' +
                          uploadResponse.Name
                        : uploadResponse.Name,
                value:
                    this.currentRenderFieldBizData &&
                    this.currentRenderFieldBizData.value
                        ? this.currentRenderFieldBizData.value +
                          ',' +
                          uploadResponse.Path
                        : uploadResponse.Path,
                name: field_name
            };

            fileUrls = {
                clientUrl: this.uploadFieldCmpData.clientUrl
                    ? this.uploadFieldCmpData.clientUrl +
                      ',' +
                      uploadResponse.ClientUrl
                    : uploadResponse.ClientUrl,
                downloadUrl: this.uploadFieldCmpData.downloadUrl
                    ? this.uploadFieldCmpData.downloadUrl +
                      ',' +
                      uploadResponse.DownLoadUrl
                    : uploadResponse.DownLoadUrl,
                fileName: this.uploadFieldCmpData.fileName
                    ? this.uploadFieldCmpData.fileName +
                      ',' +
                      uploadResponse.Name
                    : uploadResponse.Name
            };
        } else {
            filedComponentBizData = {
                text: uploadResponse.Name,
                value: uploadResponse.Path,
                name: field_name
            };

            fileUrls = {
                clientUrl: uploadResponse.ClientUrl,
                downloadUrl: uploadResponse.DownLoadUrl,
                fileName: uploadResponse.Name
            };
        }

        this.uploadFieldCmpData = Object.assign(
            this.uploadFieldCmpData,
            fileUrls
        );

        this.changeRenderedFieldValue(filedComponentBizData);
    }

    getMetaObjectName(cmpData) {
        if (isNotEmpty(cmpData, ['cmp_data', 'metaObjectName'])) {
            return cmpData.cmp_data.metaObjectName;
        }

        return (
            this.props.popOptions.cmpContext.metaObjectName ||
            this.props.popOptions.cmpContext.metaObjName
        );
    }

    getContext() {
        const context = this.props.popOptions;
        const currentRenderField = this.getCurrentRenderField();
        return {
            id: context.data.id || undefined,
            parentDataId: context.cmpContext.parentDataId || undefined,
            parentMetaObjName:
                context.cmpContext.parentMetaObjName || undefined,
            metaObjName: this.getMetaObjectName(currentRenderField),
            queryUrl: context.queryUrl,
            cmpContext: context.cmpContext
        };
    }

    getTargetModels() {
        if (this.props.firstField) {
            return this.props.selectedTableRows.map(row => {
                return { id: row['_id'], showText: row[this.props.firstField] };
            });
        }
    }

    getBatchEditSaveData() {
        const metaObjName = this.getMetaObjectName();
        const fieldText = this.currentRenderFieldBizData && this.currentRenderFieldBizData.text || '';
        let fieldValue = this.currentRenderFieldBizData && this.currentRenderFieldBizData.value;
        if(!fieldValue && fieldValue !== 0) {
          fieldValue = '';
        }
        const options = {
            checkRequired: false,
            formState: 'create',
            targetModels: this.getTargetModels(),
            metaFields: [
                {
                    metaObjName: metaObjName,
                    name: this.currentRenderFieldName,
                    text: fieldText,
                    value: fieldValue
                }
            ]
        };
        return {
            analysisData: this.props.analysisData,
            context: { metaObjName: metaObjName }, //URL中需要上下文
            options: Object.assign(options, this.props.searchData)
        };
    }

    validate() {
        const { required } = this.props.translation;
        let constraint = {};
        const field = this.currentRenderFieldName;
        const renderField = this.getCurrentRenderField();
        if (
            renderField.cmp_type === 'BC_PictureUploader' ||
            renderField.cmp_type === 'BC_FileUploader'
        ) {
            delete renderField.validators.FileExtensionValidate;
            delete renderField.validators.FileSizeValidate;
        }
        let validateResult = {
                message: '',
                error: false
            },
            validateObj = {};
        if (!renderField) {
            return (validateResult = {
                message: required,
                error: true
            });
        }
        constraint[field] = renderField ? renderField.validators : null;
        validateObj[field] = this.currentRenderFieldBizData
            ? this.currentRenderFieldBizData.value
            : '';
        //由于validate.js校验length不能是number 所以先将number转成string
        this.objValueNumberToString(validateObj);
        let result = window._beisenValidate(validateObj, constraint);
        if (result && result[field] && result[field].length > 0) {
            validateResult.error = true;
            validateResult.message = result[field][0].replace(field, '');
        }
        return validateResult;
    }
    //  将number类型的value转化为string
    objValueNumberToString(obj) {
        if (obj) {
            for (let key in obj) {
                if (typeof obj[key] === 'number') {
                    obj[key] = obj[key].toString();
                }
            }
        }
    }
    save() {
        if (this.isBluring) {
            this.isSaving = true;
            return null;
        }

        const validateResult = this.validate();
        if (
            this.state.validate_errors.error !== validateResult.error ||
            this.state.validate_errors.message !== validateResult.message
        ) {
            this.setState({ validate_errors: validateResult });
        }

        if (validateResult.error) {
            this.props.actions.showTip({
                type: 'error',
                message: validateResult.message
            });
        }

        if (!validateResult.error) {
            this.props.actions.bacthSave(this.getBatchEditSaveData(), [
                () => {
                    this.isSaving = false;
                    this.props.actions.btnNextFn();
                }
            ]);
        } else {
            this.isSaving = false;
        }
    }

    fileUploaderComponentActionsAdapter() {
        return {
            uploadFileSuccess: this.uploadFielSuccessHandle,
            deleteFile: this.deleteFileHandle
        };
    }

    render() {
        const formPartDef = this.assambleFormPartDef();
        let form_errors = {};
        form_errors[this.currentRenderFieldName] = this.state.validate_errors;

        //构造一个假的uploadFileSuccess、deleteFile action
        const actions = Object.assign(
            {},
            this.props.actions,
            this.fileUploaderComponentActionsAdapter()
        );
        return (
            <FormPart
                {...formPartDef}
                componentMap={fieldMap}
                biz_data={this.state.biz_data}
                onChange={this.onChangeHandler}
                onBlur={this.onBlurHandler}
                onFocus={this.onFocusHandler}
                form_context={this.getContext()}
                form_errors={form_errors}
                actions={actions}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/BatchEdit/BatchEdit.js